/*************************** Translations ******************************/
/*
    Sometimes you need to use a translation defined in the admin. To use it in the JS a global object is defined in the frontend.
    To use a translation add it to the global object in the frontend templates > global > javascript > translations.tpl

    In your js you can use this function:
    getTranslation('validation', 'CANT_BE_EMPTY');

 */
/* exported getTranslation */
export default (
  translationGroup,
  translationString,
  translationParams = [],
) => {
  let translation = ""; //Set translation to empty string
  //Check if translation object exists
  if (typeof translationsObj !== "undefined") {
    //Check if translation group exists
    const { [translationGroup]: group } = translationsObj; //Get the translation group
    if (group) {
      const { [translationString]: string } = group;
      translation = string ? string : "";

      translationParams.forEach((param) => {
        translation = translation.replace(/%s|%d/gi, param);
      });
    }
  }

  return translation; //Return translation
};
